import React, { FC } from "react";
import NcdcRequestProgress from "./NcdcRequestProgress";
import classNames from "classnames";
import JoinIcon from "../assets/images/icon_join.svg";
import {Link} from "react-router-dom";

type Props = {
    page: number;
    getPage: (seq: number) => void;
}

const NcdcRequestComplete: FC<Props> = ({page}) => {
    return (
        <div className={classNames('ncdc-request-form-wrapper', {'no-show': page !== 6})}>
            <div className={'ncdc-request-form'}>
                <div className={'common-form-header-wrapper'}>
                    <span className={'common-form-header-title'}>데이터 신청</span>
                    <div className={'common-form-header-circle'} />
                </div>
                <NcdcRequestProgress seq={page - 1} />
                <div className={'common-form-table-wrapper'}>
                    <div className={'text-center'}>
                        <img src={JoinIcon} alt={'데이터 신청 완료 아이콘'} />
                    </div>
                    <div className={'common-complete-text-wrapper'}>
                        <div className={'common-complete-text-header text-center'}>
                            <span>데이터 신청 완료</span>
                        </div>
                    </div>
                    <div className={'common-complete-button-wrapper text-center'}>
                        <Link to={'/'}>
                            <button>메인 페이지로 이동</button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NcdcRequestComplete;
